import React, { useMemo } from 'react';
import { useDefaultContext } from '../../../contexts/HomeContext';
import KalpIcon from '../../../assets/images/kalpIcon.svg';
import './FilterHeader.scss'

const BlockChainModal = ({ onHide }:{onHide:()=>void}) => {
  const { allChainNetwork, setChainNetwork } = useDefaultContext();

  const groupByBlockchain = useMemo( () => {
    return allChainNetwork?.reduce((acc: any, item:any) => {
      if (!acc[item.blockchain]) {
        acc[item.blockchain] = [];
      }
      acc[item.blockchain].push(item);
      return acc;
    }, {});
  }, [allChainNetwork]);

  const handleChainNetwork = (data: any, blockchain:string) => {
    setChainNetwork(data.network);
    localStorage.setItem('network', data.network);
    localStorage.setItem('blockchain', data.blockchain);
    onHide();
  };

  return (
    <div className="d-flex flex-column gap-4">
      {Object.keys(groupByBlockchain).map((blockchain, key) => {
        return (
          <div className="card-modal" key={key}>
            <span className="title">{blockchain?.toUpperCase()} DLT</span>
            <div className="d-flex flex-wrap gap-3">
                {groupByBlockchain?.[blockchain]?.map((data: any, index: number) => {
                return (
                  <div className="menu-card d-flex gap-2" key={index} onClick={() => handleChainNetwork(data, blockchain)}>
                    {/*<div className="menu-card d-flex gap-2" key={index}>*/}
                    <img src={KalpIcon} alt="icon" />
                    <div className="d-flex align-items-start flex-column" >
                      <span className="text-capitalize">{data?.name?.toUpperCase()}</span>
                      {data?.network && <span className="text-capitalize">{data?.network?.toUpperCase()}</span>}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default BlockChainModal
